import React, { useState } from 'react';
/** Services Import */
/** Components Import */
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
/** Icons Import */
import { Person, Lock } from '@mui/icons-material';
/** Images Import */
import LogoImg from '../../Assets/Images/LogoWidth.svg';
import Commons from '../../Services/Common/Common';
import { useSelector } from 'react-redux';

const StyledInput = styled('input')(({ theme, focused }) => ({
  width: '100%',
  boxSizing: 'border-box',
  paddingLeft: '44px',
  paddingRight: '16px',
  fontSize: '17px',
  color: '#111827',
  backgroundColor: '#F0FDF4',
  border: '1px solid',
  borderColor: focused ? '#2EBD36' : '#D1D5DB',
  borderRadius: '16px',
  outline: 'none',
  transition: 'all 0.2s',
  height: '56px',
  boxShadow: focused
    ? '0 0 20px -5px rgba(46, 189, 54, 0.4)'
    : '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  '&:focus': {
    borderColor: '#2EBD36',
    boxShadow: '0 0 20px -5px rgba(46, 189, 54, 0.4)',
  },
  '&::placeholder': {
    opacity: 0,
  },
}));

const StyledLabel = styled('label')(({ focused, hasValue }) => ({
  position: 'absolute',
  left: '44px',
  top: '50%',
  transform: 'translateY(-50%) scale(1)',
  transformOrigin: 'left top',
  fontSize: '1rem',
  color: '#6B7280',
  backgroundColor: 'transparent',
  paddingLeft: '0',
  paddingRight: '0',
  transition: 'all 0.2s',
  pointerEvents: 'none',
  zIndex: 2,
  borderRadius: '4px',
  opacity: hasValue || focused ? 0 : 1,
  visibility: hasValue || focused ? 'hidden' : 'visible',
}));

const StyledCheckbox = styled('input')(({ checked }) => ({
  appearance: 'none',
  width: '20px',
  height: '20px',
  border: '2px solid',
  borderColor: checked ? '#2EBD36' : '#9CA3AF',
  borderRadius: '4px',
  backgroundColor: checked ? '#2EBD36' : 'transparent',
  cursor: 'pointer',
  position: 'relative',
  transition: 'all 0.2s',
  '&:checked::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(1)',
    width: '12px',
    height: '12px',
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='white' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E\")",
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
}));

function Login(props) {
  const [focusedId, setFocusedId] = useState(false);
  const [focusedPw, setFocusedPw] = useState(false);
  const { statusBar, navBar } = useSelector((state) => state.systemBar);
  const ChangeId = (e) => {
    props.setInputs({
      ...props.inputs,
      userId: e.target.value,
    });
  };

  const ChangePw = (e) => {
    props.setInputs({
      ...props.inputs,
      userPw: e.target.value,
    });
  };

  // User ID Click Event Func
  const SelectedIds = () => {
    const inputIds = document.getElementById('LoginId');
    inputIds.select();
    inputIds.focus();
  };

  // User Password Click Event Func
  const SelectedPws = () => {
    const inputPws = document.getElementById('LoginPw');
    inputPws.select();
    inputPws.focus();
  };

  const hasValueId = props.inputs.userId.length > 0;
  const hasValuePw = props.inputs.userPw.length > 0;

  return (
    <Box
      component="main"
      sx={{
        // mb: `${navBar}px`,
        // mt: `${statusBar}px`,
        // height: `calc(100vh - ${statusBar + navBar}px)`,
        p: 3,
        pt: `${statusBar + 24}px`,
        height: `100vh`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        backgroundColor: '#F8FAFC',
        overflow: 'hidden',
        boxSizing: 'border-box',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '-10%',
          right: '-10%',
          width: '40rem',
          height: '40rem',
          borderRadius: '50%',
          background: 'rgba(46, 189, 54, 0.1)',
          filter: 'blur(80px)',
          zIndex: 0,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '-10%',
          left: '-10%',
          width: '40rem',
          height: '40rem',
          borderRadius: '50%',
          background: 'rgba(245, 158, 11, 0.1)',
          filter: 'blur(80px)',
          zIndex: 0,
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '28rem',
          position: 'relative',
          zIndex: 1,
          animation: 'fadeIn 0.5s ease-out',
          '@keyframes fadeIn': {
            '0%': {
              opacity: 0,
              transform: 'translateY(10px)',
            },
            '100%': {
              opacity: 1,
              transform: 'translateY(0)',
            },
          },
        }}
      >
        {/* 로고 섹션 */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '60%',
            mx: 'auto',
            mb: 8,
          }}
        >
          <img style={{ width: '100%' }} src={LogoImg} alt="로고 이미지" />
        </Box>

        {/* 폼 섹션 */}
        <Box
          component="form"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          {/* 아이디 입력 */}
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '14px',
                transform: 'translateY(-50%)',
                color: focusedId ? '#2EBD36' : '#9CA3AF',
                transition: 'color 0.2s',
                zIndex: 1,
                pointerEvents: 'none',
              }}
            >
              <Person sx={{ fontSize: '22px' }} />
            </Box>
            <StyledInput
              id="LoginId"
              placeholder=" "
              value={props.inputs.userId}
              onChange={ChangeId}
              onFocus={(e) => {
                setFocusedId(true);
                SelectedIds();
              }}
              onBlur={() => setFocusedId(false)}
              onClick={SelectedIds}
              focused={focusedId}
            />
            <StyledLabel
              htmlFor="LoginId"
              focused={focusedId}
              hasValue={hasValueId}
            >
              아이디를 입력해주세요
            </StyledLabel>
          </Box>

          {/* 비밀번호 입력 */}
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '14px',
                transform: 'translateY(-50%)',
                color: focusedPw ? '#2EBD36' : '#9CA3AF',
                transition: 'color 0.2s',
                zIndex: 1,
                pointerEvents: 'none',
              }}
            >
              <Lock sx={{ fontSize: '22px' }} />
            </Box>
            <StyledInput
              id="LoginPw"
              placeholder=" "
              type={!props.inputs.passwordVisible ? 'password' : 'text'}
              value={props.inputs.userPw}
              onChange={ChangePw}
              onFocus={(e) => {
                setFocusedPw(true);
                SelectedPws();
              }}
              onBlur={() => setFocusedPw(false)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  props.LoginLogic();
                }
              }}
              onClick={SelectedPws}
              focused={focusedPw}
            />
            <StyledLabel
              htmlFor="LoginPw"
              focused={focusedPw}
              hasValue={hasValuePw}
            >
              비밀번호를 입력해주세요
            </StyledLabel>
          </Box>

          {/* 체크박스 */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 0.5,
            }}
          >
            <Box
              component="label"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                cursor: 'pointer',
                userSelect: 'none',
              }}
            >
              <StyledCheckbox
                type="checkbox"
                checked={props.inputs.userIdKeep}
                onChange={(e) => props.ChangeCheckbox('id', e.target.checked)}
              />
              <Box
                component="span"
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: props.inputs.userIdKeep ? '#2EBD36' : '#4B5563',
                  transition: 'color 0.2s',
                  '&:hover': {
                    color: props.inputs.userIdKeep ? '#2EBD36' : '#4B5563',
                  },
                }}
              >
                아이디 저장
              </Box>
            </Box>
            <Box
              component="label"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                cursor: 'pointer',
                userSelect: 'none',
              }}
            >
              <StyledCheckbox
                type="checkbox"
                checked={props.inputs.loginKeep}
                onChange={(e) =>
                  props.ChangeCheckbox('account', e.target.checked)
                }
              />
              <Box
                component="span"
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: props.inputs.loginKeep ? '#2EBD36' : '#4B5563',
                  transition: 'color 0.2s',
                  '&:hover': {
                    color: props.inputs.loginKeep ? '#2EBD36' : '#4B5563',
                  },
                }}
              >
                자동 로그인
              </Box>
            </Box>
          </Box>

          {/* 버튼 */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1.5,
              pt: 2,
              mb: `${35 + navBar}px`,
            }}
          >
            <Button
              fullWidth
              onClick={() => props.LoginLogic()}
              sx={{
                backgroundColor: '#2EBD36',
                color: '#FFFFFF',
                fontSize: '17px',
                fontWeight: 600,
                height: '55px',
                borderRadius: '16px',
                boxShadow: '0 10px 15px -3px rgba(46, 189, 54, 0.25)',
                textTransform: 'none',
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.2s',
                '&:hover': {
                  backgroundColor: '#16A34A',
                  boxShadow: '0 10px 15px -3px rgba(46, 189, 54, 0.35)',
                  transform: 'scale(0.98)',
                },
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              로그인
            </Button>
            <Button
              onClick={() => props.DialogLogic('SignUp')}
              fullWidth
              sx={{
                backgroundColor: '#FFFFFF',
                color: '#4B5563',
                fontSize: '17px',
                fontWeight: 500,
                height: '55px',
                borderRadius: '16px',
                border: '1px solid #E5E7EB',
                textTransform: 'none',
                transition: 'all 0.2s',
                '&:hover': {
                  backgroundColor: '#F9FAFB',
                  color: '#2EBD36',
                  borderColor: '#2EBD36',
                },
              }}
            >
              회원가입
            </Button>
          </Box>
        </Box>
      </Box>
      {/* 버전 정보 */}
      <Box
        sx={{
          position: 'absolute',
          bottom: `${navBar}px`,
          left: '50%',
          transform: 'translateX(-50%)',
          textAlign: 'center',
          width: '100%',
          pb: 4,
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            width: '48px',
            height: '4px',
            backgroundColor: '#E5E7EB',
            borderRadius: '9999px',
            mx: 'auto',
            mb: 2,
          }}
        />
        <Box
          component="p"
          sx={{
            fontSize: '0.75rem',
            color: '#9CA3AF',
            fontFamily: 'monospace',
          }}
        >
          {Commons.Storages('get', 'version').version}
        </Box>
      </Box>
    </Box>
  );
}

export default Login;
